import * as React from "react";
import * as ReactDOM from "react-dom";
import AppContainer from './app/AppContainer';

ReactDOM.render(<AppContainer />, document.getElementById('root'));